// Simple environment-aware logger for the frontend.
// In production, logs no-op to avoid leaking info to the console.

const disabled = String(process.env.REACT_APP_DISABLE_LOGS || '').toLowerCase() === 'true';
const isDev = !disabled && process.env.NODE_ENV !== 'production';
const noop = () => {};

export const log = isDev ? console.log.bind(console) : noop;
export const warn = isDev ? console.warn.bind(console) : noop;
export const error = isDev ? console.error.bind(console) : noop;
export const debug = isDev ? console.debug?.bind(console) || console.log.bind(console) : noop;

// Assign to a named variable to satisfy import/no-anonymous-default-export
const logger = { log, warn, error, debug };
export default logger;
